module.exports = __webpack_public_path__ + "images/leasys99d8cc1167847efdf49ef233ccbc84a8.png";